Confirm = require 'app/scripts/views/lib/confirm'
ListBulkMoveCardsView = require 'app/scripts/views/list/list-bulk-move-cards-view'
ListCopyView = require 'app/scripts/views/list/list-copy-view'
ListMoveView = require 'app/scripts/views/list/list-move-view'
ListSetLimitView = require 'app/scripts/views/list/list-set-limit-view'
ListSortView = require 'app/scripts/views/list/list-sort-view'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PluginView = require 'app/scripts/views/plugin/plugin-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
template = require 'app/scripts/views/templates/list_menu'
{ Noun, Verb, track, trackUe } = require '@trello/analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
_ = require 'underscore'
{ sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'

LIST_LIMITS_POWER_UP_ID = require('@trello/config').listLimitsPowerUpId

module.exports = class ListMenuView extends PluginView
  viewTitleKey: 'list actions'

  initialize: ->
    @makeDebouncedMethods 'render'

    @listenTo @model, 'change:subscribed', @renderDebounced
    @retain @options.pluginActions

    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @templateFlagEnabled = newVal
      @renderDebounced()

  events:
    'click .js-add-card': 'addCard'
    'click .js-move-list': 'moveList'
    'click .js-copy-list': 'copyList'
    'click .js-list-subscribe': 'toggleSubscribe'

    'click .js-move-cards': 'moveCards'
    'click .js-archive-cards': 'archiveCards'

    'mouseenter .js-sort-cards': 'preloadSortBy'
    'click .js-sort-cards': 'sortBy'

    'click .js-close-list': 'closeList'

    'click .js-plugin-list-action': 'runPluginAction'

    'click .js-set-list-limit': 'setListLimit'

  render: ->
    @pluginActions = _.chain(@options.pluginActions)
      .filter (a) ->
        _.isString(a.text) &&
        a.text.length &&
        _.isFunction(a.callback)
      .map (a) ->
        _.extend(a, {
          icon: PluginIOCache.fromId(a.idPlugin).getIconUrl()
          name: PluginIOCache.fromId(a.idPlugin).getName()
        })
      .sortBy('text')
      .value()

    @$el.html(template({
      editable: @model.editable()
      hasSortableCards: @model.cardList.length > 1
      subscribed: @model.get('subscribed')
      canCopyList: !@model.isOverLimit('lists', 'totalPerBoard') &&
      !@model.isOverLimit('lists', 'openPerBoard')
      pluginActions: @pluginActions
      listLimitsEnabled: @model.getBoard().isListLimitsPowerUpEnabled()
      templateModeEnabled: @templateFlagEnabled && @model.getBoard().isTemplate()
    }))

    @

  addCard: (e) ->
    Util.stop(e)

    PopOver.hide()

    @model.getBoard().composer.save({
      list: @model
      index: 0
      vis: true
    })

    track("List Menu", "Add Card")
    track('Card Composer', 'Open', 'Via List Menu')

    return

  moveList: (e) ->
    Util.stop(e)

    track("List Menu", "Open Move List Popover")
    PopOver.pushView
      view: new ListMoveView({ @model, @modelCache })

    return

  copyList: (e) ->
    Util.stop(e)

    track("List Menu", "Open Copy List Popover")
    PopOver.pushView
      view: new ListCopyView({ @model, @modelCache })

    return

  toggleSubscribe: (e) ->
    Util.preventDefault(e)
    if @model.get('subscribed')
      @model.subscribe(false)
      track("List Menu", "Subscribe", "Unsubscribe")
    else
      @model.subscribe(true)
      track("List Menu", "Subscribe", "Subscribe")
    return

  moveCards: (e) ->
    Util.stop(e)
    track("List Menu", "Open Move All Cards in List")

    PopOver.pushView
      view: new ListBulkMoveCardsView({ @model, @modelCache })

    return

  archiveCards: (e) ->
    Util.stop(e)
    track("List Menu", "Open Archive All Cards in List")

    Confirm.pushView 'archive all cards',
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        PopOver.hide()

        openCards = _.clone(@model.cardList.models)
        for card in openCards
          card.set({ closed: true })

        @model.run 'archiveAllCards',
          {},
          @listViewListen

    return

  loadPluginSorters: (timeout) ->
    PluginRunner.all
      command: 'list-sorters'
      board: @model.getBoard()
      list: @model
      timeout: timeout
    .catch ->
      []
    .then (pluginListSorters) =>
      # limit to 5 sorts per plugin
      limitedSorts = _.chain(pluginListSorters)
        .groupBy('idPlugin')
        .map (val, idPlugin) -> val.slice(0, 5)
        .flatten()
        .value()

  preloadSortBy: (e) ->
    if !@pluginSortersPromise?
      @pluginSortersPromise = @loadPluginSorters(500)
      .then (pluginListSorters) =>
        @pluginSortersPromise = null
        @pluginListSorters = pluginListSorters
        @pluginListSortersExpiry = Date.now() + 5000
        return pluginListSorters

  sortBy: (e) ->
    Util.stop(e)
    track("List Menu", "Open Sort Cards in List")

    pluginListSorters = []

    if @pluginListSorters? && @pluginListSortersExpiry > Date.now()
      pluginListSorters = @pluginListSorters
    else if @pluginSortersPromise?
      pluginListSorters = @pluginSortersPromise
    else
      pluginListSorters = @loadPluginSorters(150)

    Promise.resolve(pluginListSorters)
    .then (pluginListSorters) =>
      PopOver.pushView
        view: new ListSortView({ @model, @modelCache, pluginListSorters })
      @pluginListSorters = null

  setListLimit: (e) ->
    Util.stop(e)
    trackUe(Noun.LIST_MENU, Verb.OPENS, Noun.POWER_UP, '', '', 'list-action', LIST_LIMITS_POWER_UP_ID)
    PopOver.pushView
      view: new ListSetLimitView({ @model, @modelCache })

  runPluginAction: (e) ->
    Util.stop(e)

    target = @pluginActions[@$(e.target).closest('.js-plugin-list-action').data('index')]

    { idPlugin } = target

    trackUe(Noun.LIST_MENU, Verb.OPENS, Noun.POWER_UP, '', '', 'list-action', idPlugin)

    sendPluginUIEvent(idPlugin, {
      action: 'clicked'
      actionSubject: 'option'
      source: 'listMenuInlineDialog'
      actionSubjectId: 'powerUpListAction'
      objectType: 'powerUp'
      objectId: idPlugin
    })

    target.callback?({ el: @el, list: @model })

  closeList: (e) ->
    Util.stop(e)

    view = @
    model = @model

    track("List Menu", "Archive List")
    PopOver.hide()
    model.close()

    false
